import { Configuration } from '@trybeapp/sdk';
var baseConfiguration = {
    // The SDK includes `/shop` in its URLs, so we take it off the end
    // of the Mix base URL before setting.
    basePath: process.env.MIX_BASE_API_URL.substring(0, -5),
};
export var apiConfiguration = new Configuration(baseConfiguration);
